<template>
    <div>
        <Header></Header>
        <div class="search">
          <input v-model="keyword" placeholder="キーワードを入力してください" @keyup.enter="Search"><br>
          <button @click="Search">検索</button>
        </div>
        <div class="contents">
            <!-- <search-result2 ref="searchResult2" v-bind:inputedKeyword="keyword"></search-result2> -->
            <div>
              <div class="top-message">
                <h1>検索結果</h1>
                  <div v-if="!myItems.length && isClicked">
                    <p>検索結果が見つかりませんでした。</p><br>
                    <p>違うキーワードをお試しください。</p>
                  </div>
                  <div v-else>
                    <div class="searchResult">
                        <ul>
                            <li v-for="item in myItems" :key="item.itemID">
                                <router-link :to="{name: 'itemDetail', params:{id: item.itemID}}" >
                                    <figure class="relative">
                                      <img :src="item.img_url" @click="selected(item)">
                                      <figcaption class="abusolute"><p>{{item.price}}円</p></figcaption>
                                    </figure>
                                    <p v-if="item.isSold" class="sold">販売中</p>
                                    <p v-else class="soldout">売り切れ</p>
                                    <p>{{item.item}}</p>
                                </router-link>
                            </li>
                        </ul>
                      </div>
                  </div>
              </div>
            </div>
          </div>
          <menu-bar class="menu-bar"></menu-bar>
    </div>
</template>


<script>
import firebase from 'firebase'
import db from '../plugins/firestore'
import Header from '../components/Header.vue'
import MenuBar from '../components/MenuBar.vue'
// import Footer from '../components/Footer.vue'
// import SearchResult2 from './SearchResult2.vue'

export default {
    components: {Header, MenuBar},
    data(){
      return {
        items: [], //検索結果を格納する配列
        keyword: '', //入力するキーワード
        isPushed: false, //検索ボタンが押されたかどうかのフラグ
        myItems: [],
        isClicked: false
      }
    },
    //生成時にログイン状態を確認する。userオブジェクトが取得できなかったら（未ログイン状態なら）ランディングページに飛ばす
    created() {
      firebase.auth().onAuthStateChanged(user => {
        if(!user){
            this.$router.push({path: "/"})
        }else{
          this.myItems = this.$store.getters.searchResult
        }
      })
    },
    methods: {
        //検索ボタンが押されたら、入力されたキーワードと商品名が一致するものをfirestoreから取得してmyItemsに入れる。
        //そして、templateでmyItemsをv-forで表示していく。.where("item", "==", this.inputedKeyword)
        Search(){
          if(this.keyword==''){
            alert('商品名が空白です')
          }else{

            sessionStorage.setItem('key', this.keyword)
            db.collection("textbooks").orderBy("item").startAt(this.keyword).endAt(this.keyword+'\uf8ff').get().then(snap => {
            const array = [];
            snap.forEach(doc => {
                const itemData = doc.data(); //itemDataオブジェクト（商品情報）を設定
                itemData.itemID = doc.id; //itemDataにドキュメントIDを付与
                array.push(itemData); //itemDataを配列arrayに入れる
            });
            this.myItems = array
            this.$store.dispatch('searchResult', this.myItems)
            this.isClicked = true
            });
          }
        },
        //商品画像がクリックされたら、vuexにその商品のIDを格納して、ItemDetail.vueからアクセスできるようにする。
        selected(item){
            this.$store.dispatch('selected', item)
        }
    }
}
</script>

<style scoped>
.contents{
  text-align: center;
  margin: 0 auto;
}

.search {
      display: flex;
      margin: 0 auto;
}

.search button{
  background-color:rgba(255,0, 0, 0.9);
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 8px 10px;
  margin-left:2%;
  /* margin: 30px 0; */
  color: white;
  display: inline-block;
  opacity: 0.8;
  border-radius:7px;
  text-align: center;
}

.search input{
    /* text-align: center; */
    width: 30%;
    height: 30px;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 0px 10px;
    border-style: solid;
    border-width: 0.5px;
    border-radius: 10px;
    margin-left:25% ;
    /* margin: 0 auto; */
}

.searchResult {
  text-align: center;
  margin: 0 auto;
}

.searchResult img {
    width: 200px;
    height: 200px;
    object-fit: cover;
}


.searchResult{
    margin: 20px auto;
    width: 55%;
}

.searchResult p{
  text-align: left;
}

ul {
    display: flex;
    list-style: none;
    flex-wrap: wrap;
}

li {
    margin: 10px;
    width: 200px;
    /* border-radius: 5px; */
    box-sizing: border-box;
    box-shadow: 0 0 5px #999;
    /* background-color: aqua; */
}

li:hover{
  opacity: 0.8;

}

.sold {
    margin-left: 5px;
    border-radius: 5px;
    padding: 0px 10px;
    color: white;
    width: 50px;
    background-color: rgba(255,0, 0, 1);
}

.soldout {
  margin-left: 5px;
  border-radius: 5px;
  padding: 0px 10px;
  color: white;
  width: 65px;
  background-color: rgb(200, 200, 200);
}

.relative {
  width: 200px;
  position: relative;
}

.abusolute {
  bottom: 15px;
  position: absolute;
  color: white;
  background-color: rgba(50, 50, 50, 0.7);
  border-radius: 0 15px 15px 0;
}

.abusolute p {
  font-size: 20px;
  padding: 0px 15px;
}

p {
  padding: 0 15px;
}

/* メニューバー */
.menu-bar {
    position: absolute !important;
    bottom: 0 !important;
    width: 100%;
}

@media all and (max-width:670px){
    .top-message h1{
        font-size: 20px;
    }

    .input{
        /* margin-left: 130px; */
    }
    .searchResult{
        width: 98%;
        margin-top: 20px auto;
    }

    li {
        width: 110px;
        margin: auto;
        margin-top: 10px;
    }
    
    p {
      font-size: 13px;
      padding: 0 10px;
    }

    .sold {
      width: 40px;
    }

    .soldout {
      width: 53px;
    }

    img {
        width: 110px!important;
        height: 110px!important;
        object-fit: cover;
    }

    .relative {
      width: 95px;
      position: relative;
    }

    .abusolute {
      bottom: 15px;
      position: absolute;
      color: white;
      background-color: rgba(50, 50, 50, 0.7);
      border-radius: 0 15px 15px 0;
    }

    .abusolute p {
      font-size: 13px;
    }

    .search{
      width:100% ;
      margin:0 0;
    }


    .search input{
        text-align: center;
        width: 40%;
        height: 30px;
        margin-top: 20px;
        margin-bottom: 20px;
        padding: 0px 10px;
        border-style: solid;
        border-width: 0.5px;
        border-radius: 10px;
        /* margin-left:35% ; */
    }

      .search button{
        background-color:rgba(255,0, 0, 0.9);
        margin-top: 20px;
        margin-bottom: 20px;
        padding: 8px 10px;
        /* margin-left:2%; */
        /* margin: 30px 0; */
        color: white;
        display: inline-block;
        opacity: 0.8;
        border-radius:7px;
        /* text-align: center; */
      }
}
</style>